(() => {
  const originals = new WeakMap();
  const candidates = '.tls-hero-art img,.romance-editorial-art>img,.tls-card-image img,.editable-product-image img,.tls-card>a>img,.editable-couple>summary>img,.tls-product-gallery img,.editable-photo img,.catchup-desktop-image img,.tls-prose img,.tls-cart-line>a>img';
  const desktop = matchMedia('(min-width:801px)');
  function options(img) {
    if (!(img instanceof HTMLImageElement) || !img.matches(candidates)) return null;
    const section = img.closest('.shopify-section');
    const config = section?.querySelector('[data-tls-photo-config]');
    if (!config) return null;
    try { return JSON.parse(config.textContent); } catch { return null; }
  }
  function alternate(img) {
    const holder = img.closest('[data-tls-alternate]');
    if (holder?.classList.contains('tls-product-gallery') && holder.querySelector('img') !== img) return '';
    return holder?.dataset.tlsAlternate || '';
  }
  function restore(img) {
    const old = originals.get(img);
    if (!old) return;
    img.src = old.src;
    if (old.srcset === null) img.removeAttribute('srcset'); else img.setAttribute('srcset', old.srcset);
    if (old.style === null) img.removeAttribute('style'); else img.setAttribute('style', old.style);
    originals.delete(img);
  }
  document.addEventListener('pointerover', event => {
    const img = event.target;
    const config = options(img);
    if (!config?.alternate || !desktop.matches || event.pointerType === 'touch' || !alternate(img) || originals.has(img)) return;
    originals.set(img, { src:img.getAttribute('src'), srcset:img.getAttribute('srcset'), style:img.getAttribute('style'), originalURL:img.currentSrc || img.src });
    const height = img.getBoundingClientRect().height;
    img.style.setProperty('height', height + 'px', 'important');
    img.style.setProperty('object-fit', 'contain', 'important');
    img.removeAttribute('srcset');
    img.src = alternate(img);
  });
  document.addEventListener('pointerout', event => { if (event.target instanceof HTMLImageElement) restore(event.target); });
  document.addEventListener('error', event => { if (event.target instanceof HTMLImageElement) restore(event.target); }, true);

  let dialog, viewerImage, caption, next, opener, images = [], index = 0, priorOverflow;
  function showImage() { viewerImage.src = images[index]; next.hidden = images.length < 2; next.textContent = index ? 'Original image' : 'Next image'; }
  function open(img) {
    const config = options(img);
    if (!config || !(desktop.matches ? config.desktop : config.mobile)) return false;
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'tls-image-dialog';
      dialog.setAttribute('aria-label', 'Full image viewer');
      dialog.innerHTML = '<div class="tls-image-dialog-bar"><button type="button" data-image-close>Close image ×</button></div><img class="tls-image-dialog-photo" alt=""><p class="tls-image-dialog-caption"></p><button type="button" data-image-next>Next image</button>';
      document.body.append(dialog);
      viewerImage = dialog.querySelector('img'); caption = dialog.querySelector('p'); next = dialog.querySelector('[data-image-next]');
      dialog.querySelector('[data-image-close]').addEventListener('click', () => dialog.close());
      next.addEventListener('click', () => { index = (index + 1) % images.length; showImage(); });
      dialog.addEventListener('keydown', event => { if (images.length > 1 && ['ArrowRight','ArrowLeft'].includes(event.key)) { event.preventDefault(); index = (index + 1) % images.length; showImage(); } });
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => { document.body.style.overflow = priorOverflow; if (opener?.isConnected) opener.focus({preventScroll:true}); });
    }
    const old = originals.get(img);
    const original = old?.originalURL || img.currentSrc || img.src;
    const other = alternate(img);
    images = other && other !== original ? [original,other] : [original];
    index = old && images.length > 1 ? 1 : 0;
    restore(img);
    opener = img;
    viewerImage.alt = img.alt || 'Full image';
    caption.textContent = img.alt || '';
    showImage(); priorOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; dialog.showModal();
    return true;
  }
  document.addEventListener('click', event => {
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (open(event.target)) { event.preventDefault(); event.stopPropagation(); }
  }, true);
  document.addEventListener('keydown', event => {
    if (['Enter',' '].includes(event.key) && open(event.target)) { event.preventDefault(); event.stopPropagation(); }
  }, true);
  function refresh() {
    document.querySelectorAll(candidates).forEach(img => {
      const config = options(img);
      const enabled = config && (desktop.matches ? config.desktop : config.mobile);
      if (enabled) {
        if (!img.hasAttribute('data-tls-focus-original')) {
          img.dataset.tlsFocusOriginal = JSON.stringify({tabindex:img.getAttribute('tabindex'),role:img.getAttribute('role'),'aria-label':img.getAttribute('aria-label'),'aria-haspopup':img.getAttribute('aria-haspopup')});
        }
        img.setAttribute('tabindex','0'); img.setAttribute('role','button'); img.setAttribute('aria-haspopup','dialog'); img.setAttribute('aria-label', 'View full image' + (img.alt ? ': ' + img.alt : '')); img.classList.add('tls-image-viewable');
      } else if (img.hasAttribute('data-tls-focus-original')) {
        const attributes = JSON.parse(img.dataset.tlsFocusOriginal);
        for (const [key,value] of Object.entries(attributes)) { if(value === null) img.removeAttribute(key); else img.setAttribute(key,value); }
        img.removeAttribute('data-tls-focus-original'); img.classList.remove('tls-image-viewable');
      }
      if (!desktop.matches) restore(img);
    });
  }
  new MutationObserver(refresh).observe(document.body,{childList:true,subtree:true});
  desktop.addEventListener('change',refresh); document.addEventListener('shopify:section:load',refresh); refresh();
})();

(()=>{function setup(){document.querySelectorAll('[data-tls-story]:not(.is-ready)').forEach(el=>{const btn=el.querySelector('button');if(!btn)return;el.classList.add('is-ready');btn.hidden=false;btn.addEventListener('click',()=>{const open=el.classList.toggle('is-open');btn.setAttribute('aria-expanded',String(open));btn.textContent=open?btn.dataset.less:btn.dataset.more;});});}setup();document.addEventListener('shopify:section:load',setup);})();
